/* MDR — Footer: stato "in invio" della newsletter (evita doppi invii) e ritorno al messaggio dopo l'iscrizione. */
(function () {
  'use strict';
  var form = document.getElementById('mdr-footer-newsletter-form');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.mdr-footer__submit');
      form.classList.add('is-loading');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); }
      window.setTimeout(function () { if (btn) btn.disabled = true; }, 0);
    });
  }
  /* dopo l'iscrizione Shopify ricarica la pagina con ?customer_posted=true: porta in vista il messaggio */
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var box = document.getElementById('mdr-footer-newsletter');
    if (box && box.scrollIntoView) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(function () { box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); }, 300);
    }
  }
}());
